<template>
    <div class="form-group filter-input">
        <label :for="htmlFor">{{ title }}</label>
        <div 
            :class="filterStyle" 
            class="input-group">
            <div class="input-group-btn">
                <button 
                    :class="buttonClass" 
                    type="button" 
                    class="btn dropdown-toggle"
                    data-toggle="dropdown" 
                    aria-expanded="false">
                    {{ buttonText }}
                    <span class="fa fa-caret-down"/>
                </button>
                <ul class="dropdown-menu">
                    <li><a 
                        href="#" 
                        @click.prevent="updateHasValue(1)">da</a></li>
                    <li><a 
                        href="#" 
                        @click.prevent="updateHasValue(-1)">ne</a></li>
                    <li class="divider"/>
                    <li><a 
                        href="#" 
                        @click.prevent="updateHasValue(0)">ponastavi</a></li>
                </ul>
            </div>
            <input 
                :id="htmlFor" 
                :placeholder="title"
                :disabled="hasValue !== 0" 
                :value="value" 
                class="form-control"
                type="text" 
                @input="$emit('input', $event.target.value)">
        </div>
    </div>
</template>

<script>
export default {
    name: 'ContactSearchText',

    props: {
        value:   {
            required: true
        },
        has:     {
            required: true
        },
        htmlFor: {
            required: true,
            type:     String
        },
        title:   {
            required: true,
            type:     String
        },
    },

    data() {
        return {
            hasValue: this.has
        };
    },

    computed: {
        buttonText() {
            switch (Number(this.hasValue)) {
            case 1:
                return 'da';
            case 0:
                return 'da / ne';
            case -1:
                return 'ne';
            }
        },

        buttonClass() {
            switch (Number(this.hasValue)) {
            case 1:
                return 'btn-success';
            case 0:
                return 'btn-default';
            case -1:
                return 'btn-danger';
            }
        },

        filterStyle() {
            return this.value ? 'filter-active-input' : '';
        }
    },

    watch: {
        has(current) {
            this.$set(this, 'hasValue', current);
        }
    },

    methods: {
        updateHasValue(value) {
            this.$set(this, 'hasValue', value);
            this.$emit('update:has', value);
            this.$parent.submit();
        }
    }
};
</script>

<style scoped>
    .btn {
        border-radius: 0;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/Contacts/Components/Text.vue